import React, { useState } from 'react';
import { useParams, useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Helmet } from 'react-helmet-async';
import CircularLoader from 'app/design/uiComponents/CircularLoader';
import { groupBy, encodeUrlData, decodeUrlData } from 'utils/GenericFunctions';
import PositionsListLayout from 'app/design/layouts/PositionsListLayout';
import BotHistoryPositionsModal from 'app/components/Bots/BotHistory/BotHistoryPositionsModal';
import ContentTabs from 'app/design/itemsComponent/ContentTabs';

// Service
import { Position } from 'types/ApiServicesTypes';
import PageHeader from 'app/design/speedBot/PageHeader';
import useGetBotPositions from 'services/Bots/useGetBotPositions';
import FormattedMessage from 'app/design/uiComponents/FormattedMessage';
import { PositionsListLayoutProps } from 'types/ComponentTypes';
import Breadcrumbs from 'app/design/uiComponents/Breadcrumbs';
import { PAGES } from 'app/components/Common/Breadcrumb/types';

export function PortfolioPositionsPage() {
  const { id, title, ptype, bid } =
    useParams<{ id: string; title: string; ptype?: string; bid: string }>();
  const { t } = useTranslation();
  const titleData = decodeUrlData(title);
  const history = useHistory();
  const [page, setPage] = React.useState<number>(1);
  const [openModal, setOpenModal] = useState<boolean>(false);
  const [selectedPosition, setSelectedPosition] = useState<Position | null>(
    null,
  );

  const baseApiUrl = `portfolio/${id}`;

  // For change tab
  const handleChange = (newValue: number) => {
    const path = `/${'portfolio'}/${ptype}/${id}/orders/${encodeUrlData(
      titleData,
    )}/${bid}`;
    if (newValue === 1) {
      history.replace({ pathname: path });
    }
    if (newValue === 2) {
      history.replace({
        pathname: `/${'portfolio'}/${ptype}/${id}/signals/${encodeUrlData(
          titleData,
        )}/${bid}`,
      });
    }
  };

  const botId = parseInt(id);
  const { data, isLoading } = useGetBotPositions(botId, page, baseApiUrl);

  const totalPages =
    data && data.length > 0 ? Number(data[0]['total_pages']) : 0;
  const botPositions = data && data.length > 0 ? data : [];
  const botGrpPositions = groupBy(
    botPositions,
    'exit_time',
    true,
  ) as PositionsListLayoutProps;

  const handleChangePagination = (
    event: React.ChangeEvent<unknown>,
    value: number,
  ) => {
    setPage(value);
  };

  const handleModalOpen = (positionData: Position) => {
    setSelectedPosition(positionData);
    setOpenModal(true);
  };

  const handleModalClose = () => {
    setOpenModal(false);
    setSelectedPosition(null);
  };
  const manualInUrl = () => {
    return window.location.pathname.includes('manual');
  };
  const tabsData = [
    { label: t('buttons.position') },
    { label: t('buttons.order') },
  ];

  const isManual = manualInUrl();
  if (isManual) {
    tabsData.push({ label: 'Signals' });
  }
  return (
    <>
      <Helmet>
        <title>Portfolio Positions</title>
        <meta name="description" content="Portfolio Positions Page" />
      </Helmet>
      <CircularLoader open={isLoading} />
      <PageHeader
        variant="tabsWithBack"
        buttonText={`${titleData}`}
        buttonHandleClick={() => history.goBack()}
        breadcrumb={
          <Breadcrumbs
            page={PAGES.PORTFOLIO_DETAIL_POSITIONS}
            data={{ botName: title, ptype: ptype, subId: id }}
          />
        }
        tabs={
          <ContentTabs
            value={0}
            onChange={(e, newVal) => handleChange(newVal)}
            tabs={tabsData}
          />
        }
      />
      <PositionsListLayout
        data={botGrpPositions}
        page={page}
        totalPages={totalPages}
        handleChangePagination={handleChangePagination}
        handleClick={handleModalOpen}
        handleChangeTab={handleChange}
      />
      <BotHistoryPositionsModal
        open={openModal}
        handleClose={handleModalClose}
        data={selectedPosition || null}
        title={<FormattedMessage id="buttons.position" />}
      />
    </>
  );
}
